import uuidv4 from "uuid/v4";
import { allowOverscrollOnElement } from "office-ui-fabric-react";

export const messagesReducer = (state, action) => {
  switch (action.type) {
    case "SET_INITIAL_MESSAGES":
      return {
        ...state,
        messages: action.payload,
        currentMessage: {}
      };
    case "ADD_MESSAGE":
      const withAddedMessage = [...state.messages, action.payload];
      return {
        ...state,
        messages: withAddedMessage
      };
      case "ADD_MESSAGES":
        const withAddedMessages = [...state.messages,...action.payload];
        return {
          ...state,
          messages:withAddedMessages
        };  
      case "SET_SELECTED_ITEMS":
       const _selectedItems = [...action.payload.selectedItems]; 
      return {
        ...state,
        selectedItems:_selectedItems
      };  
      case "SET_CURRENT_MESSAGE":
      return {
        ...state,
        currentMessage: action.payload
      };
    case "TOGGLE_MESSAGE":
      const toggledMessages = state.messages.map(m =>
        m.id === action.payload.id ? {...action.payload, selected : !action.payload.selected} : m
      );
      return {
        ...state,
        messages: toggledMessages
      };

    case "UPDATE_MESSAGE":
      const updatedMessage = { ...action.payload };
      const updatedMessageIndex = state.messages.findIndex(
        m => m.id === state.currentMessage.id
      );
      const updatedMessages = [
        ...state.messages.slice(0, updatedMessageIndex),
        updatedMessage,
        ...state.messages.slice(updatedMessageIndex + 1)
      ];

      return {
        ...state,
        currentMessage: {},
        messages: updatedMessages
      };
    case "REMOVE_MESSAGE":
      const filteredMessages = state.messages.filter(
        m => m.id !== action.payload.id
      );
      const isRemovedMessage =
        state.currentMessage.id === action.payload.id
          ? {}
          : state.currentMessage;
      return {
        ...state,
        currentMessage: isRemovedMessage,
        messages: filteredMessages
      };
      
      case "REMOVE_MESSAGES":
        return {
          ...state,
          messages: [],
          textBody: '',
          htmlBody: ''
        };
    case "TOGGLE_ALL_MESSAGES":
      const toggledAllMessages = state.messages.map((m) =>({...m, selected : !m.selected}));
      return {
        ...state,
        messages: toggledAllMessages
      };
      case "SELECT_ALL_MESSAGES":
      const selectedAllMessages = state.messages.map((m) =>({...m, selected : true}));
      return {
        ...state,
        messages: selectedAllMessages
      };
      
      case "UNSELECT_ALL_MESSAGES":
      const unSelectedAllMessages = state.messages.map((m) =>({...m, selected : false}));
      return {
        ...state,
        messages: unSelectedAllMessages
      };

      case "SET_BODY_CONTENT":
      return {
        ...state,
        bodyContent: action.payload.bodyContent,
        bodyContentType: action.payload.bodyContentType
      };
      case "SET_TEXT_BODY":
      return {
        ...state,
        textBody: action.payload.textBody
      };
      case "SET_HTML_BODY":
        //alert(`SET_HTML_BODY ${action.payload.htmlBody}`)
      return {
        ...state,
        htmlBody: action.payload.htmlBody
      };
      case "SET_EDITOR_STATE":
        return {
          ...state,
          editorState: action.payload.editorState
        };
      case "SET_RENDER_FORMAT":
      return {
        ...state,
        renderFormat: action.payload.renderFormat
      };
      case "SET_TITLE_CONTENT":
      return {
        ...state,
        titleContent: action.payload.bodyContent,
        titleContentType: action.payload.bodyContentType
      };
      case "SET_EDIT_SELECTED_ITEMS":
        return {
          ...state,
          loadSelectedItems: action.payload.loadSelectedItems
        };
        case "SET_PIVOT_KEY":
          return {
            ...state,
            pivotKey: action.payload.pivotKey
          };
        case "SET_ACCESS_TOKEN":
          //console.log(`********************@REDUCER : ${JSON.stringify(action.payload.accessToken)}`)
          return {
            ...state,
            accesssToken: action.payload.accessToken
          };
          case "SET_EMAIL_FROM":
          return {
          ...state,
          emailFrom: action.payload.emailFrom
          };  
          case "SET_EMAIL_TO":
          return {
          ...state,
          emailTo: action.payload.emailTo
          };  
          case "SET_EMAIL_SUBJECT":
          return {
          ...state,
          emailSubject: action.payload.emailSubject
          };  
          case "SET_EMAIL_HEADER":
          return {
          ...state,
          emailHeader: action.payload.emailHeader
          };  
          case "SET_EMAIL_FOOTER":
          return {
          ...state,
          emailFooter: action.payload.emailFooter
          };
          case "SET_NUMER_OF_ITEMS_IN_PAGE":
          return {
          ...state,
          numberOfItemsInPage: action.payload.numberOfItemsInPage
          };
          case "SET_LOG_LEVEL":
          return {
          ...state,
          logLevel: action.payload.logLevel
          };              
    default:
      return state;
  }
};








































      // case "REMOVE_MESSAGES":
      //   //console.log(`REMOVE_MESSAGES: ${JSON.stringify(action.payload)}`);
      //    const _filteredMessages = state.messages.filter(
      //      _qmessege => {     
      //       const _message = _qmessege;
      //       const result = action.payload.selectedItems.find(
      //           __message => {
      //           //console.log(` __message.id: ${ __message.id} _message.id: ${_message.id}`);
      //           const v = __message.id === _message.id ? false : true;
      //           return v;
      //         }
              
      //         );
              
      //       const _value = result === undefined ? false : true;
      //       return _value;
      //     }
      //    );
      // //alert('filtered messages: ' + JSON.stringify(_filteredMessages));
      //   return {
      //     ...state,
      //     messages: [..._filteredMessages],
      //     loadSelectedItems: true,
      //     selectedItems: [],
      //     textBody: '',
      //     htmlBody: '',
      //     editorState: ''
      //   };
